import React, { useContext } from 'react';
import { withStyles, Theme } from '@material-ui/core';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import Button, { ButtonProps } from '@material-ui/core/Button';
import { colors } from '../../../constants/colors';
import { fontFamily } from '../../../constants/text';
import { ToggleButtonGroupContext } from './ToggleButtonGroup';

const buttonStyles = (theme: Theme) =>
  ({
    buttonRoot: {
      borderRadius: '4px',
      padding: '4px',
    },
    button: {
      height: '56px',
      boxSizing: 'border-box',
      color: theme.palette.grey['600'],
      padding: '16px 24px',
      textTransform: 'none',
      fontFamily: fontFamily.regular,
    },
    buttonChecked: {
      backgroundColor: colors.emptyBarGrey,
      border: `2px solid ${theme.palette.grey['600']}`,
      '&:focus': {
        borderColor: theme.palette.primary.main,
      },
    },
  } as const);

export type ToggleButtonProps = {
  classes: any;
  label: string;
  value: any;
} & RadioProps &
  ButtonProps;

const ToggleButton = withStyles(buttonStyles, { withTheme: true })(
  ({ classes, value, label, ...rest }: ToggleButtonProps) => {
    const { disabled } = useContext(ToggleButtonGroupContext);
    const combined = { ...rest, disabled };
    return (
      <Radio
        value={value}
        {...combined}
        checkedIcon={
          <Button
            className={`${classes.button} ${classes.buttonChecked}`}
            tabIndex={-1}
            variant="outlined"
            {...combined}
          >
            {label}
          </Button>
        }
        classes={{ root: classes.buttonRoot }}
        icon={
          <Button className={classes.button} tabIndex={-1} variant="outlined" {...combined}>
            {label}
          </Button>
        }
      />
    );
  }
);

export default ToggleButton;
